<template>
    <AnswerResult/>
</template>
<script>
import AnswerResult from 'place/answer/answerResult.vue'
export default {
    components:{
        AnswerResult
    }
}
</script>